export enum CondicaoPagamentoEnum {
    
	A_VISTA = "A_VISTA",
	PARCELADO = "PARCELADO"

  }
  